// Test file to verify Buffer polyfill is working
import { BlobServiceClient } from "@azure/storage-blob";

// Function to test if Buffer is defined
export function testBuffer() {
  try {
    console.log("Testing if Buffer is defined...");
    console.log("Buffer exists:", typeof window.Buffer !== 'undefined');
    
    // Try to use Buffer to create a simple buffer
    if (typeof window.Buffer !== 'undefined') {
      const testBuffer = window.Buffer.from("Test string");
      console.log("Successfully created a buffer:", testBuffer);
      return true;
    } else {
      console.error("Buffer is not defined");
      return false;
    }
  } catch (error) {
    console.error("Error testing Buffer:", error);
    return false;
  }
}

// Function to test Azure Storage initialization
export function testAzureStorage(accountName, sasToken) {
  try {
    console.log("Testing Azure Storage initialization with SAS token...");
    
    // Create test values if none provided
    const testAccountName = accountName || "testaccount";
    const testSasToken = sasToken || "?sv=2020-08-04&ss=b&srt=sco&sp=rwdlacx&se=2025-12-31T00:00:00Z&st=2025-01-01T00:00:00Z&spr=https&sig=testSignature";
    
    // Create the blob service URL with the SAS token
    const blobServiceUrl = `https://${testAccountName}.blob.core.windows.net${testSasToken}`;
    
    // Try to create a BlobServiceClient
    const blobServiceClient = new BlobServiceClient(blobServiceUrl);
    
    console.log("Successfully created BlobServiceClient:", blobServiceClient);
    return true;
  } catch (error) {
    console.error("Error initializing Azure Storage:", error);
    return false;
  }
}
